'use client'

import { Builder } from '@builder.io/react'

import { Price } from './Price'

Builder.registerComponent(Price, {
  name: 'Price',
  inputs: [
    {
      name: 'oldPrice',
      type: 'string',
      defaultValue: '45.99',
    },
    {
      name: 'oldPriceSuffix',
      type: 'string',
      defaultValue: '/mo',
    },
    {
      name: 'newPrice',
      type: 'string',
      defaultValue: '25.99',
    },
    {
      name: 'newPriceSuffix',
      type: 'string',
      defaultValue: '/mo',
    },
    {
      name: 'size',
      type: 'enum',
      defaultValue: 'small',
      enum: ['small', 'large'],
    },
    {
      name: 'currencySymbol',
      type: 'string',
      defaultValue: '$',
      enum: ['$', 'C$', 'CA$', '€', '£'],
    },
    {
      name: 'symbolPosition',
      type: 'string',
      defaultValue: 'before',
      enum: ['before', 'after'],
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/currency-dollar.svg',
})
